export const formatDMRConfirmationNumber = (confirmationNumber: number | string) => confirmationNumber.toString().replace(/(.{5})(?=.)/g, "$1-").trim();
